<template>
  <div class="search-page">
    <Form
      :model="searchData"
      inline
      :label-width="0"
      label-position="right"
      class="search-list-430 search-wrapper-430"
    >
      <FormItem label="">
        <Input
          v-model="searchData.studentName"
          clearable
          placeholder="输入学生姓名"
          class="search-input-430"
          @on-change="handleSearchData"
        ></Input>
      </FormItem>
      <FormItem label="">
        <RemoteSelect
          v-if="theUserIdentity === 'admin'"
          v-model="searchData.schoolId"
          :remote-method="getSchoolList"
          :loading="schoolLoading"
          placeholder="选择学校"
          @clear="getSchoolList('')"
          @change="handleSearchData"
          @visible-change="loadAllList"
        >
          <el-option
            v-for="item in schoolList"
            :key="item.schoolId"
            :label="item.schoolName"
            :value="item.schoolId"
          >
          </el-option>
        </RemoteSelect>
        <!-- <Select
          v-if="theUserIdentity === 'admin'"
          v-model="searchData.schoolId"
          filterable
          clearable
          :remote-method="getSchoolList"
          :loading="schoolLoading"
          @on-clear="handleClearSchool"
          @on-change="handleSearchData"
        >
          <Option
            v-for="option in schoolList"
            :key="option.schoolId"
            :value="option.schoolId"
          >{{ option.schoolName }}</Option>
        </Select> -->
        <div v-if="theUserIdentity === 'school'" style="width: 200px">
          {{ userInfo.orgName }}
        </div>
      </FormItem>

      <FormItem label="">
        <Input
          v-model="searchData.oldClassroomName"
          clearable
          placeholder="输入原课程名称"
          class="search-input-430"
          @on-change="handleSearchData"
        ></Input>
      </FormItem>
      <FormItem label="">
        <Input
          v-model="searchData.newProductName"
          clearable
          placeholder="输入调班课程名称"
          class="search-input-430"
          @on-change="handleSearchData"
        ></Input>
      </FormItem>
      <FormItem label="">
        <Input
          v-model="searchData.newClassroomName"
          clearable
          placeholder="输入调班班级名称"
          class="search-input-430"
          @on-change="handleSearchData"
        ></Input>
      </FormItem>
      <Button type="primary" class="btn-mr" @click="handleSearch">查询</Button>
      <Button @click="handleReset">重置</Button>
    </Form>
  </div>
</template>

<script>
import commonApi from '@/request/common/index.js';
import RemoteSelect from '@c/RemoteSelect';
import { mapGetters } from 'vuex';
export default {
  name: 'ShiftPage',
  components: {
    RemoteSelect
  },
  data() {
    return {
      schoolLoading: false,
      schoolList: [],
      searchData: {
        schoolId: null,
        studentName: null,
        oldClassroomName: null,
        newProductName: null,
        newClassroomName: null
      },
      schoolPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      schoolId: ''
    };
  },
  computed: {
    ...mapGetters(['theUserIdentity', 'userInfo'])
  },
  created() {
  },
  mounted() {
    if (this.theUserIdentity === 'school') {
      this.schoolId = this.userInfo.orgId;
      this.searchData.schoolId = this.schoolId;
      this.$emit('input', this.searchData);
    } else {
      this.schByOpe();
    }
  },
  methods: {
    loadAllList(val) {
      if (!val) {
        this.getSchoolList('');
      }
    },
    // 获取学校列表
    getSchoolList(query) {
      console.log('query', query);
      query ? (this.schoolLoading = true) : '';
      const queryTrue = query && query.length === 1 ? '' : query;
      this.schByOpe(queryTrue);
    },
    handleClearSchool() {
      this.schByOpe();
    },
    // 请求学校列表(运营端)
    async schByOpe(query) {
      const params = this.schoolPageInfo;
      query === undefined
        ? (params.searchStr = '')
        : (params.searchStr = query);
      const res = await commonApi.schByOpe(params);
      if (res.status === 200) {
        this.schoolList = res.message.list.map(item => {
          item.schoolId = item.orgId;
          item.schoolName = item.name;
          return item;
        });
        this.schoolPageInfo.total = Number(res.message.total);
        this.schoolLoading = false;
      }
    },
    getOrgList() { },
    handleSearchData() {
      this.emitData();
    },
    handleSearch() {
      this.$emit('handleSearch', this.searchData);
    },
    handleReset() {
      this.searchData = {
        schoolId: this.theUserIdentity === 'school' ? this.schoolId : null,
        studentName: null,
        oldClassroomName: null,
        newProductName: null,
        newClassroomName: null
        // PageNum: 1,
        // PageSize: 10
      };
      const pageInfo = {
        total: 0,
        PageNum: 1,
        PageSize: 10
      };
      this.$emit('input', this.searchData);
      this.$emit('handleReset', pageInfo);
    },
    emitData() {
      this.$emit('input', this.searchData);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-page {
  .aaa {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .btn-mr {
    margin-right: 16px;
  }
}
</style>
